import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 * 评分状态
 * @param params
*/

export const getGradeStatus = params => Http.get(`${baseUrl}/chapter/team/grade/score/status`, { params })

/**
 * 开始评分
 * @param params
*/

export const startGrade = params => Http.post(`${baseUrl}/chapter/team/grade/score/${params.classChapterId}/start`)

/**
 * 评分项目列表
 * @param params
*/

export const getGradeItemList = params => Http.get(`${baseUrl}/chapter/team/grade/item`, { params })

/**
 * 新增评分项目
 * @param params
*/

export const addGradeItem = params => Http.post(`${baseUrl}/chapter/team/grade/item`, params)

/**
 * 修改评分项目
 * @param params
*/

export const editGradeItem = params => Http.put(`${baseUrl}/chapter/team/grade/item`, params)

/**
 * 删除评分项目
 * @param ids
 * 
*/

export const delGradeItem = ids => Http.delete(`${baseUrl}/chapter/team/grade/item/${ids}` )

/**
 * 评分团队列表
 * @param params
*/

export const getGradeTeamList = params => Http.get(`${baseUrl}/chapter/team/grade/score`, { params })

/**
 * 评分项列表
 * @param params
*/

export const getGradeInfo = params => Http.get(`${baseUrl}/chapter/team/grade/score/info`, { params })

/**
 * 评分
 * @param params
*/

export const giveGrade = params => Http.post(`${baseUrl}/chapter/team/grade/score`, params)

/**
 * 成绩结算
 * @param params
*/

export const setGrade = params => Http.post(`${baseUrl}/chapter/team/grade/score/calc`, params)

/**
 * 团队排名
 * @param params
*/

export const teamRanking = params => Http.get(`${baseUrl}/chapter/team/grade/top/team`, { params })

/**
 * 个人排名
 * @param params
*/

export const memberRanking = params => Http.get(`${baseUrl}/chapter/team/grade/top/post`, { params })

/**
 * 项目排序
 * @param params
*/

export const sort = params => Http.put(`${baseUrl}/chapter/team/grade/item/sort`,  params )

/**
 * 重置项目
 * @param classChapterId
*/

export const reset = classChapterId => Http.post(`${baseUrl}/chapter/team/grade/item/${classChapterId}/reset` )

/**
 * 导入项目列表
 * @param params
*/

export const upLoad = params => Http.post(`${baseUrl}/chapter/team/grade/item/${params.classChapterId}/import`,  params.file )

/**
 * 评分比例
 * @param params
*/

export const scoreWeight = params => Http.get(`${baseUrl}/chapter/team/grade/score/radio`, { params })

/**
 * 评分比例
 * @param params
*/

export const editScoreWeight = params => Http.post(`${baseUrl}/chapter/team/grade/score/radio`,  params )
